import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import MyAccountNav from '../components/MyAccountNav';
import MyAccountFAQs from '../components/MyAccountFAQs';
import MightyPointsSummary from '../features/customer/MightyPointsSummary';
import { selectToken } from '../features/user/userSlice';
import {
  loadOrders,
  resetOrders,
  selectOrders,
  selectOrdersLoadComplete,
  selectOrdersPagesLoaded,
  selectOrdersTotalPages
} from '../features/orders/ordersSlice';
import RecentOrder from '../features/orders/RecentOrder';
import LoginForm from '../features/user/LoginForm';
import RegisterForm from '../features/user/RegisterForm';
import OrderObj from '../features/orders/orderObj';
import CircularProgressBar from './Progressbar/CircularProgressBar';
import { selectCustomerDetails, selectCustomerDetailsIsLoaded, selectCustomerDetailsIsLoading } from '../features/customer/customerDetailSlice';
import CustomerAPI from '../API/customerAPI';
import { selectIsMobileRoute, setRefferalBtnText, setRefferalCode, setRefferalSMSBodyText } from '../features/mobile/mobileSlice';
import CustomerObj from '../features/customer/customerObj';
import { selectCustomer } from '../features/customer/customerSlice';

export default function MyAccountPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const pages_loaded: number = useSelector(selectOrdersPagesLoaded);
  const total_pages: number = useSelector(selectOrdersTotalPages);
  const orders = useSelector(selectOrders);
  const ordersLoaded = useSelector(selectOrdersLoadComplete);
  const order = OrderObj.findRecentOrder(orders);
  const [progress, setProgress] = useState(0);
  const customerData = useSelector(selectCustomerDetails);
  const customerLoading = useSelector(selectCustomerDetailsIsLoading);
  const customerLoaded = useSelector(selectCustomerDetailsIsLoaded);
  const customerDetails = customerData?.user_data;
  const customer = new CustomerObj(useSelector(selectCustomer));
  const customerEmail = customer?.data?.email;
  const AppURL = useSelector(selectIsMobileRoute);

  useEffect(() => {
    handleReferFriends(customerEmail);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (customerDetails) {
      const totalFields = Object.keys(customerDetails).filter(key => !key.includes('address_two') && !key.includes('number_of_children_in_household') && !key.includes('imageUrl')).length;
      const numCompletedFields = Object.values(customerDetails).filter((val, index) => val !== "" && val !== null && !Object.keys(customerDetails)[index].includes('address_two') && !Object.keys(customerDetails)[index].includes('number_of_children_in_household') && !Object.keys(customerDetails)[index].includes('imageUrl')).length;
      const ProgressBar = Math.round((numCompletedFields / totalFields) * 100);
      setProgress(ProgressBar);
    }
  }, [customerDetails])

  useEffect(() => {
    dispatch(resetOrders());
  }, [dispatch]);

  useEffect(() => {
    if (token && (!pages_loaded || pages_loaded < total_pages)) {
      dispatch(loadOrders(token));
    }
  }, [token, pages_loaded, total_pages, dispatch]);

  const handleReferFriends = async (email: string) => {
    await CustomerAPI.referFriendSMS(
      email,
    ).then((response) => {
      if (response?.status === 200) {
        dispatch(setRefferalCode(response?.code))
        dispatch(setRefferalSMSBodyText(response?.sms_body_text))
        dispatch(setRefferalBtnText(response?.sms_button_text))
      }
      if ('errors' in response) console.log(response.errors);
    }).catch((e) => {
      console.log([e.message]);
    })
  }

  return (
    <Container fluid="lg" className='my-account-page'>
      {token ?
        <Row>
          <Col xs={12} md={3} >
            <MyAccountNav />
          </Col>
          <Col xs={12} md={9}>
            <div className={`${(!customerLoading && customerLoaded && customerData) ? progress === 100 ? 'bg-green' : 'bg-yellow' : 'bg-yellow'} font-barlow mt-5 my-3 d-flex flex-wrap justify-content-center justify-content-md-between rounded overflow-hidden`}>
              <div className='p-4 px-xl-5 col-12 col-md-7'>
                <CircularProgressBar progress={progress} /> 
                {(!customerLoading && customerLoaded && customerData) ? 
                <>
                    {progress === 100 ?
                      <>
                        <h1 className='fw-400 mt-3 text-uppercase text-sm'>
                          <span className='fw-700'>You Got 1 Free Meal</span>
                        </h1>
                        <h4>Thanks for filling in your profile</h4>
                        <h5 className='font-glegoo fw-bold text-primary-200'>Use Code <strong className='text-decoration-underline'>1FREEMVP</strong> To Get<br/> Your Free Meal.</h5>
                      </> :
                      <>
                        <h1 className='fw-500 mt-2 text-uppercase text-bannerlarge font-barlow'>
                          <span className='fw-800'>get 1</span> free mightymeal
                        </h1>
                        <h5 className='text-primary-200'>for completing your profile so we may better customize your ordering experience.</h5>
                        <Button 
                          variant="dark"
                          className='bg-black mt-3'
                          onClick={() => navigate(`/my-account/edit-account${AppURL}`)}>
                            EDIT PROFILE
                        </Button>
                      </>
                    }
                  </> : 
                  <div className='text-center my-5 h-100'>
                    <Spinner className="text-center text-dark" variant="primary" animation="grow" />
                </div>}
              </div>
              <div className='col-9 col-md-5 d-md-flex justify-content-end'>
                <img src={`${process.env.REACT_APP_BLOG_URL}/wp-content/uploads/2023/03/meals-mobile.png`} alt="" className='align-self-center d-xl-none' />
                <img src={`${process.env.REACT_APP_BLOG_URL}/wp-content/uploads/2023/03/meals.png`} alt="" className='h-100 object-fit-cover d-none d-xl-block' />
              </div>
            </div>

            <Row className='my-4'>
              <Col xs={12} lg={8}>
                <div className='bg-image h-100'>
                  <div className='bg-linear-gradient p-4 h-100 rounded'>
                    <div className='col-lg-10'>
                      <h2 className='text-success fw-800 font-barlow'>REFER A FRIEND</h2>
                      <h3 className='text-white font-barlow fw-500'>GIVE $100 | GET $50</h3>
                      <p className='text-white fw-400 w-60 lh-lg' style={{fontFamily: 'Glegoo'}}>Give friends <span className='fw-bold'>$100</span> off
                        their first four orders and you'll
                        get <span className='fw-bold'>$50</span> worth of Mighty
                        Points when they purchase.</p>
                      <div>
                        <Button
                          variant="success"
                          size="sm"
                          as={Link as any}
                          to="/my-account/refer-a-friend"
                        >
                          Start Sharing!
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={4} className='mt-4 my-lg-0'>
                <MightyPointsSummary />
              </Col>
            </Row>
            {(ordersLoaded && order) &&
              <Row className='my-4'>
                <Col xs={12}>
                  <RecentOrder />
                </Col>
              </Row>}
            <Row className='my-4'>
              <Col xs={12} lg={4} className='mb-4 mb-lg-0'>
                <Card className='text-black font-barlow fw-700 border border-2 border-black m-1pct p-3 fs-20px h-100'>
                  <div className='my-auto'>
                    <h2 className='text-center mb-4'>Support</h2>
                    <div className='d-grid gap-3'>
                      <Button
                        variant="dark"
                        size="lg"
                        className='bg-black'
                        onClick={() => {
                          const el = document.getElementById('my-account-faqs');
                          if (el) el.scrollIntoView();
                        }}
                      >
                        View FAQs
                      </Button>
                      <Button
                        variant="dark"
                        size="lg"
                        className='bg-black'
                        onClick={() => {
                          window.open("https://mightymeals.freshdesk.com/support/home", '_blank')
                        }}
                      >
                        Contact Us
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
              <Col xs={12} lg={4} className='mb-4 mb-lg-0 text-center'>
                <Card className='text-black font-barlow fw-700 border border-2 border-black  m-1pct p-3 fs-20px h-100'>
                  <h2 className='text-center mb-4'>Quality Feedback</h2>
                  <p className='font-barlow fs-20px'>
                    Rate your experience and tell us about your meal quality. This helps
                    us perfect our menu to better serve you!
                  </p>
                  <div className='d-grid'>
                    <Button
                      variant="dark"
                      size="lg"
                      className='bg-black'
                      onClick={() => {
                        window.open("https://www.surveymonkey.com/r/QMJPZM5", '_blank')
                      }}
                    >
                      Feedback Form
                    </Button>
                  </div>
                </Card>
              </Col>
              <Col xs={12} lg={4} className=' text-center'>
                <Card className='text-black font-barlow fw-700 border border-2 border-black  m-1pct p-3 fs-20px h-100'>
                  <div className='my-auto'>
                    <h2 className='mb-4'>Website Experience</h2>
                    <p className='font-barlow fs-20px'>
                      Tell us about your website ordering experience. This helps us
                      perfect our site  to better serve you!
                    </p>
                    <div className='d-grid'>
                      <Button
                        variant="dark"
                        size="lg"
                        className='bg-black'
                        onClick={() => {
                          window.open("https://www.surveymonkey.com/r/QT28GT7", '_blank')
                        }}
                      >
                        Fill Out Survey
                      </Button>
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>
            <MyAccountFAQs />
          </Col>
        </Row>
        :
        <Row>
          <Col xs={12} md={6}>
            <h2 className="my-4">Login</h2>
            <LoginForm />
          </Col>
          <Col xs={12} md={6}>
            <h2 className="my-4">Register</h2>
            <RegisterForm />
          </Col>
        </Row>
      }
    </Container>
  );
}
